/*
 * state.js -- JEDINE misto v celem JS sablony terrahunt-2026, ktere sahá
 * na `document.body.classList`.
 *
 * PROC TO NENI KOSMETIKA: tyhle tridy nejsou interni promenna modulu, ale
 * VEREJNY KONTRAKT pro externi GTM chatbot widget
 * (docs/chatbot-position-contract.md, plan 07-04). Widget podle nich
 * pocita offset bubliny a rozhoduje, kdy se schovat. Kdyby si tridy
 * prepinal kazdy modul sam, neexistovalo by misto, kde je videt uplny
 * seznam stavu -- a kontrakt by se rozesel s implementaci pri prvni
 * zmene, kterou by nikdo neprocetl.
 *
 * PRAVIDLO PRO NAVAZUJICI MODULY (07-03 menu.js, 07-04 dock.js a dal):
 * zadny z nich nesmi volat `classList` na <body> primo. Vzdy pres
 * `setState()`. Stejne tak zadny modul chrome nesmi pouzit `innerHTML`
 * (hrozba T-07-01-01, ASVS V5) -- na vse, co chrome potrebuje, staci
 * `classList`, `setAttribute` a `textContent`.
 *
 * Neznamé jméno se TISE ignoruje. Je to zamer: kdyby setState psalo
 * cokoli, co dostane, stacil by preklep v navazujicim modulu k tomu, aby
 * na <body> trvale visela trida, kterou zadne CSS nezna a zadny gate
 * nehlida. Allowlist je zaroven ta jedina evidence stavu, kterou kontrakt
 * slibuje widgetu.
 *
 * Direktiva 'use strict' tu zamerne NENI: ES modul je striktni ze zakona
 * a eslint.config.js ji pravidlem `strict: ['error','never']` zakazuje.
 */

/**
 * Uplny seznam stavu, ktere smi na <body> vzniknout.
 *
 * menu-open        otevrene overlay menu (07-03)
 * dock-full        spodni lista v plne sirce (07-04)
 * dock-mini        jen kruhove tel: tlacitko nad formularovou sekci (07-04)
 * dock-hidden      lista skryta (pred prahem scrollu, nad patickou, klavesnice)
 * kbd-active       otevrena virtualni klavesnice (focusin + visualViewport)
 * map-mode         rezim mapy -- v F0.5 jen definice + CSS hook, spousti az F4
 * chatbot-fab-left zivy chatbot FAB detekovany v DOM vlevo dole (07-04 Task 3);
 *                  lista podle ni uhne kruhovym tel: tlacitkem, aby se prvky
 *                  neprekryly. MUSI byt v allowlistu uz ted -- jinak by ji
 *                  setState v 07-04 tise zahodilo a kolize by se nasla az
 *                  vizualne.
 *
 * KOMBINACE STAVU VYNUCUJE `enforceInvariant()` (07-07, bod 12) -- allowlist
 * rika, JAKY stav smi vzniknout, invariant rika, KTERE stavy spolu smi stat.
 * Dokumentovany je v docs/chatbot-position-contract.md, sekce 2.
 */
const STATES = [
	'menu-open',
	'dock-full',
	'dock-mini',
	'dock-hidden',
	'kbd-active',
	'map-mode',
	'chatbot-fab-left',
];

/**
 * Selektory, ktere jsou soucasti kontraktu mezi chrome a komponentami.
 *
 * FORM_SECTION zamerne NENI natvrdo v dock.js: v F0.5 zadna formularova
 * komponenta neexistuje (testuje se na fixture) a F1a ji dostane na jedno
 * jedine misto, ktere staci prepsat.
 */
const contracts = {
	FORM_SECTION: '.formsec',
	FOOTER: 'footer',
	/*
	 * Boční panel s vlastním CTA (detail hry: `.gdet-side`, spolupráce: `coop-dside.php`, obecný `sidebox.php`).
	 * Dock se na desktopu neukáže, dokud spodek panelu zasahuje do zóny docku
	 * (majitel 8. 10. 2026: plovoucí CTA se překrývalo s CTA v panelu).
	 */
	SIDE_PANEL: '.gdet-side, .coop-dside, .dside',
};

/**
 * Skupiny stavu, ktere se vzajemne VYLUCUJI (07-07, bod 12).
 *
 * `dock-full` / `dock-mini` / `dock-hidden` jsou tri podoby jednoho a tehoz
 * prvku. Dva soucasne by nebyla jen kosmeticka vada: externi chatbot widget
 * podle nich pocita spodni hranu bubliny (kontrakt sekce 2) a pri dvou
 * platnych stavech by dostal dve ruzne odpovedi na tutez otazku.
 */
const EXCLUSIVE_GROUPS = [['dock-full', 'dock-mini', 'dock-hidden']];

/**
 * Stavy, ktere ODVOZUJI jine stavy.
 *
 * Otevrena klavesnice i otevrene menu znamenaji, ze lista musi byt pryc --
 * jinak stoji pres rozepsane pole, resp. pod panelem menu. Do 07-06 to byla
 * jen konvence v dokumentu; ted to vynucuje kod, takze poradi volani
 * `setState()` v navazujicich modulech uz nemuze vyrobit nekonzistentni
 * kombinaci.
 */
const IMPLIES = {
	'kbd-active': ['dock-hidden'],
	'menu-open': ['dock-hidden'],
};

/**
 * Odebere z vylucne skupiny vsechny cleny krome jednoho.
 *
 * @param {DOMTokenList} list Tridy na <body>.
 * @param {string} keep Stav, ktery ma zustat.
 * @return {void}
 */
function keepOnly(list, keep) {
	for (let g = 0; g < EXCLUSIVE_GROUPS.length; g += 1) {
		const group = EXCLUSIVE_GROUPS[g];
		if (group.indexOf(keep) === -1) {
			continue;
		}
		for (let i = 0; i < group.length; i += 1) {
			if (group[i] !== keep) {
				list.remove(group[i]);
			}
		}
	}
}

/**
 * Srovna stavy na <body> do platne kombinace.
 *
 * PORADI JE SOUCAST PRAVIDLA: nejdriv implikace, potom vylucnost. Kdyby to
 * bylo naopak, prepsal by cerstve zapsany `dock-full` odvozeny `dock-hidden`
 * a pri otevrene klavesnici by lista naskocila zpatky.
 *
 * Verejne kvuli meritelnosti -- `_07-dock-states.cjs` si tim overi invariant
 * primo, bez cekani na to, az ho nejaky scroll nahodou vyvola.
 *
 * @param {HTMLElement} body Telo dokumentu.
 * @param {string} [written] Stav, ktery se prave zapsal (ma prednost ve
 *                           vylucne skupine).
 * @return {void}
 */
function enforceInvariant(body, written) {
	const list = body.classList;

	const keys = Object.keys(IMPLIES);
	for (let k = 0; k < keys.length; k += 1) {
		if (!list.contains(keys[k])) {
			continue;
		}
		const forced = IMPLIES[keys[k]];
		for (let f = 0; f < forced.length; f += 1) {
			list.add(forced[f]);
			keepOnly(list, forced[f]);
		}
	}

	for (let g = 0; g < EXCLUSIVE_GROUPS.length; g += 1) {
		const group = EXCLUSIVE_GROUPS[g];
		const on = [];
		for (let i = 0; i < group.length; i += 1) {
			if (list.contains(group[i])) {
				on.push(group[i]);
			}
		}
		if (on.length < 2) {
			continue;
		}
		// Prednost ma prave zapsany stav; bez nej posledni v poradi skupiny.
		const keep = (written && on.indexOf(written) !== -1) ? written : on[on.length - 1];
		keepOnly(list, keep);
	}
}

/**
 * Prepne stav na <body>.
 *
 * @param {string} name Jméno stavu z allowlistu STATES.
 * @param {boolean} on  true = pridat, false = odebrat.
 * @return {boolean} true, pokud se stav opravdu zapsal.
 */
function setState(name, on) {
	if (STATES.indexOf(name) === -1) {
		return false;
	}

	const body = document.body;
	if (!body) {
		return false;
	}

	body.classList.toggle(name, !!on);
	enforceInvariant(body, name);
	return true;
}

/**
 * Je stav prave aktivni?
 *
 * Cist stav umi kdokoli, ZAPISOVAT smi jen tenhle modul -- proto je
 * getter tady a ne v modulech, ktere by si jinak sahly na classList samy.
 *
 * @param {string} name Jméno stavu.
 * @return {boolean}
 */
function hasState(name) {
	return !!document.body && document.body.classList.contains(name);
}

/**
 * Kopie allowlistu pro verejny namespace (window.TH2026.states).
 *
 * Vraci se KOPIE, ne interni pole: kontrakt je ke cteni, ne k rozsirovani
 * zvenci.
 *
 * @return {string[]}
 */
function states() {
	return STATES.slice();
}

export { setState, hasState, states, contracts, enforceInvariant };
